var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 590 360",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 295,
    y: 210,
    textAnchor: "middle",
    fontSize: 100,
    fontWeight: 900,
    fontFamily: "Arial, sans-serif",
    fill: "#fff"
  }, "X"), /*#__PURE__*/React.createElement("text", {
    x: 295,
    y: 340,
    textAnchor: "middle",
    fontSize: 90,
    fontWeight: "bold",
    fontFamily: "Arial, sans-serif",
    fill: "#fff",
    letterSpacing: 16
  }, "AI"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.58bca2cd1ec332b7ce4a076fe4025c7c.svg";
export { ForwardRef as ReactComponent };